import { LinkRequestStatus } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { queriesLinkRequests } from "@query";
import { PendingInvitationAlert } from "./PendingInvitationAlert";

/**
 * Dashboard alerts for the logged-in user's unaccepted v3 invitations. Renders
 * one accept-able alert per Pending request, and nothing when there are none, so
 * it is safe to mount unconditionally in the alerts stack.
 *
 * Reads the **incoming** list, not `listPayerPayeeLinkRequests`. The latter is
 * the owner-side list of one relationship's requests and rejects a call without
 * `filter[payerPayeeId][eq]` (422 `ValidationError`), so asking it for "every
 * invitation addressed to me" failed on every dashboard load. `/incoming` is
 * scoped to the caller and filters on status server-side — the same call
 * `acceptPendingLinkRequests` already makes.
 */
export const PendingInvitationsAlerts: React.FC = () => {
  const queryLinkRequests =
    queriesLinkRequests.listIncomingPayerPayeeLinkRequests.useQuery({
      filter: { status: { anyOf: [LinkRequestStatus.PENDING] } }
    });

  const pendingLinkRequests = useMemo(
    () => queryLinkRequests.data?.data ?? [],
    [queryLinkRequests.data]
  );

  return (
    <>
      {pendingLinkRequests.map(linkRequest => (
        <PendingInvitationAlert
          key={linkRequest.id}
          linkRequest={linkRequest}
        />
      ))}
    </>
  );
};
